/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Fix accessibility

import { FC, useState } from 'react';
import { IMAGES_REPO } from '../../../../static-resources';
import './publishedBy.component.scss';

interface PublishedByProps {
  videoUrl: string;
}

export const PublishedByComponent: FC<PublishedByProps> = ({ videoUrl }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(videoUrl)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      })
      .catch((err) => {
        // TODO: Handle error
      });
  };

  // Open Outlook (or default email client) with a pre-filled email template
  const openOutlook = () => {
    const subject = encodeURIComponent('Check out this video');
    const body = encodeURIComponent(
      `Hi,\n\nI found this video and thought you might like it:\n${videoUrl}`,
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <div className="d-flex justify-content-between align-items-center publishedBy">
      <div className="d-flex publishedBy-person">
        <div className="d-flex justify-content-center flex-column">
          <span className="publishedBy-content-header">Written by</span>
          <span className="publishedBy-content-text">Tyler Willing</span>
        </div>
        <div className="d-flex justify-content-center flex-column">
          <span className="publishedBy-content-header">Published on</span>
          <span className="publishedBy-content-text">17 Jan 2024</span>
        </div>
      </div>

      <div className="d-flex publishedBy-social-content">
        <div
          className={`d-flex justify-content-center align-items-center copy-link ${isCopied ? 'copied' : ''}`}
          onClick={copyToClipboard}
        >
          <img src={IMAGES_REPO.CopyIcon} alt="Copy link" />
          <span>{isCopied ? 'Copied!' : 'Copy link'}</span>
        </div>
        <img src={IMAGES_REPO.TeamsIcon} alt="Teams" />
        <img
          src={IMAGES_REPO.OutlookIcon}
          alt="Outlook"
          onClick={openOutlook}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </div>
  );
};

export default PublishedByComponent;
